<template>
  <div>
    <v-btn @click="startSpin" class="btn-container white--text" color="mainPink"
      >start</v-btn
    >
    <slot-machine ref="slotMachine" />
  </div>
</template>

<script>
import { mapState } from "vuex";

import SlotMachine from "./SlotMachine.vue";
export default {
  name: "SlotPanel",
  components: {
    SlotMachine,
  },
  data() {
    return {};
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch("fetchDataKado");
    },
    startSpin() {
      // console.log(
      //   this.$store.state.slotMachine.slots,
      //   "< data dari state di parent"
      // );
      this.$refs.slotMachine.start();
    },
  },
};
</script>

<style>
.btn-container {
  position: absolute;
  top: 4vh;
  right: 6vw;
}

.btn-style {
}
</style>
